import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Snackbar from '@material-ui/core/Snackbar';
import API from '../api/ApiTool';


const getIdx = (serviceProvider) => {
  switch(serviceProvider) {
    case 'fs':
    case 'fs-central':
      return 0;
    case 'fs10v5':
      return 1;        
    case 'node-cc':
      return 2;
    case 'fs-atl':
      return 3;
    case 'Twilio':
    case 'twilio':
      return -1;
    case 'plivo':
    case 'Plivo':
      return -1;
    default:      
      return -1;
   }
  };

export default function ServiceProviderSelector(props) {  

  //const [options, setOptions] = React.useState(['fs-central', 'fs10v5', 'node-cc', 'fs-beta'])
  var options = ['fs-central', 'fs10v5', 'node-cc', 'fs-atl'];
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [number, setNumber] = React.useState(props.number.replace("+", ""));
  const [success, setSuccess] = React.useState(false);

  console.log('serviceProvider', props.number, props.serviceProvider)
  var curIdx = getIdx(props.serviceProvider)
  if (curIdx == -1) {
    options = [props.serviceProvider];
    curIdx = 0;
  }

  console.log('setSelectedIndex', curIdx, options)
  const [selectedIndex, setSelectedIndex] = React.useState(curIdx);
  //setSelectedIndex(curIdx)

  React.useEffect( () => {
    console.log('Props Changed', props);
    curIdx = getIdx(props.serviceProvider)
    if (curIdx >= 0) {
      setSelectedIndex(curIdx)
    }
  }, [props.serviceProvider])
  
  

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(null);    

    API.POST(`/bridges/telnyx-tools/update_number/`, 
      {phone_number: number, provider: options[index]})
      .then(response => response.json())
      .then(data => {        
        setSuccess(true)
      })    
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSuccess(false)
  };

  return (
    
    <div >
      <Snackbar open={success} autoHideDuration={2000} onClose={handleClose}
        message={`Sucess on update ${number} to ${options[selectedIndex]}`} />
      
      <List component="nav" aria-label="" >
        <ListItem
          button
          aria-haspopup="true"
          aria-controls="lock-menu"          
          onClick={handleClickListItem}
        >
          <ListItemText primary={options[selectedIndex]} />
        </ListItem>
      </List>
      <Menu 
        id="lock-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((option, index) => (
          
          <MenuItem 
            key={option}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ServiceProviderSelector.js